/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  LIGHT_GREY,
  BLACK_PEARL,
  SUNRISE_50,
  WHITE,
  PALE_GRAY,
  BRIGHT_BLUE,
} from 'constants/colors'

export const customStyles = {
  container: (baseStyles) => ({
    ...baseStyles,
    minWidth: '200px',
    width: '100%',
    fontFamily: 'Gibson',
    fontSize: '16px',
    fontStyle: 'normal',
  }),
  option: (baseStyles) => ({
    ...baseStyles,
    color: BLACK_PEARL,
    backgroundColor: WHITE,
    height: '50px',
    paddingLeft: '13px',
    borderTop: `1px solid ${PALE_GRAY}`,
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: SUNRISE_50,
    },
    '&:first-of-type': {
      borderTop: 'none',
    },
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: BLACK_PEARL,
    fontWeight: '500',
    lineHeight: '40px',
    paddingLeft: '5px',
  }),
  dropdownIndicator: (baseStyles) => ({
    ...baseStyles,
    color: BRIGHT_BLUE,
  }),
  control: (baseStyles, { menuIsOpen }) => ({
    ...baseStyles,
    border: `1px solid ${LIGHT_GREY}`,
    boxShadow: 'none',
    borderRadius: '100px',
    backgroundColor: WHITE,
    height: '50px',
    '&:hover': {
      border: `1px solid ${LIGHT_GREY}`,
    },
    ...(menuIsOpen && {
      borderRadius: '25px 25px 0px 0px',
      transition: 'border-radius 0.1s ease-out',
    }),
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    color: 'transparent',
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    color: BLACK_PEARL,
    margin: '0px',
    border: `1px solid ${LIGHT_GREY}`,
    borderTop: 'none',
    fontWeight: '400',
    boxShadow: `0px 3px 6px 0px rgba(33, 37, 41, 0.12)`,
    borderRadius: '0px 0px 25px 25px',
    overflow: 'hidden',
  }),
  menuList: (baseStyles) => ({
    ...baseStyles,
    borderRadius: '0px 0px 25px 25px',
    paddingBottom: '0px',
    paddingTop: '0px',
  }),
}
